import { motion } from "framer-motion";

const Loading = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6">

        {/* Logo / Brand */}
        <motion.img
          src="/btilogo.jpeg"
          alt="Loading"
          className="w-20 h-20 object-contain"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.6,
            ease: "easeOut",
          }}
        />

        {/* Spinner */}
        <motion.div
          className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full"
          animate={{ rotate: 360 }}
          transition={{
            repeat: Infinity,
            duration: 1,
            ease: "linear",
          }}
        />

        {/* Loading Text */}
        <motion.p
          className="text-sm tracking-[0.2em] uppercase text-dark/50 font-semibold"
          initial={{ opacity: 0 }}
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{
            repeat: Infinity,
            duration: 1.5,
          }}
        >
          Loading...
        </motion.p>
      </div>
    </div>
  );
};

export default Loading;